import { render, staticRenderFns } from "./UnableToOfferHeader.vue?vue&type=template&id=86d96254"
import script from "./UnableToOfferHeader.vue?vue&type=script&lang=js"
export * from "./UnableToOfferHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports